export default __webpack_public_path__ + "cd6f0f74e226fa9ffd129e4f93500ad4.jpeg";